import React, { useState, useEffect } from 'react'
import Modal from '../common/Modal'
import { fetchParams, saveParams } from '../../services/paramsApi'
import '../../css/params.css'

const CHANNELS = [
  { key: 'Live',   id: '1' },
  { key: '+24',    id: '2' },
  { key: 'Best',   id: '3' },
  { key: 'Hit',    id: '4' },
  { key: 'Italia', id: '5' },
  { key: 'TV',     id: '6' },
]

export default function ParamsFormModalExt({ open, onClose, onSaved }) {
  const [loading,   setLoading]   = useState(false)
  const [saving,    setSaving]    = useState(false)
  const [dinamici,  setDinamici]  = useState({})
  const [statici,   setStatici]   = useState({})
  const [audio,     setAudio]     = useState({ first: 0, ad: 0, last: 0 })
  const [video,     setVideo]     = useState({ first: 0, ad: 0, last: 0 })
  const [channels,  setChannels]  = useState({})
  const [error,     setError]     = useState(null)

  // RESET quando chiudi il modal
  useEffect(() => {
    if (!open) {
      setDinamici({})
      setStatici({})
      setAudio({ first: 0, ad: 0, last: 0 })
      setVideo({ first: 0, ad: 0, last: 0 })
      setChannels({})
      setError(null)
    }
  }, [open])

  // CARICAMENTO params
  useEffect(() => {
    if (!open) return

    let isActive = true
    setError(null)
    setLoading(true)

    ;(async () => {
      try {
        const { dinamici, statici } = await fetchParams()
        if (!isActive) return

        console.log('📥 fetched dinamici:', dinamici)
        console.log('📥 fetched statici:',  statici)

        setDinamici(dinamici)
        setStatici(statici)

        // parsatura CSV
        const [a0, a1, a2] = (dinamici.n_proll_audio?.split(',') || []).map(n => +n)
        const [v0, v1, v2] = (dinamici.n_proll_video?.split(',') || []).map(n => +n)
        const chIds        = (dinamici.proll_ok?.split(',')       || [])

        setAudio({ first: a0 || 0, ad: a1 || 0, last: a2 || 0 })
        setVideo({ first: v0 || 0, ad: v1 || 0, last: v2 || 0 })

        const chState = {}
        CHANNELS.forEach(c => {
          chState[c.id] = chIds.includes(c.id)
        })
        setChannels(chState)

      } catch (e) {
        console.error(e)
        if (isActive) setError('Errore caricamento')
      } finally {
        if (isActive) setLoading(false)
      }
    })()

    return () => { isActive = false }
  }, [open])

  // SALVATAGGIO
  const handleSave = async () => {
    setSaving(true)
    setError(null)
    try {
      const newDin = {
        ...dinamici,
        n_proll_audio: `${audio.first},${audio.ad},${audio.last}`,
        n_proll_video: `${video.first},${video.ad},${video.last}`,
        proll_ok: Object.entries(channels)
                         .filter(([_,v]) => v)
                         .map(([k]) => k)
                         .join(','),
      }
      await saveParams({ dinamici: newDin, statici })
      onSaved()
      onClose()
    } catch (e) {
      console.error(e)
      setError('Errore salvataggio')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal open={open} onClose={onClose}>
      <h3>Parametri Preroll</h3>
      {error && <p className="error">{error}</p>}
      {loading
        ? <p>Caricamento…</p>
        : (
        <div className="params-container">
          {/* Audio */}
          <fieldset>
            <legend>Modifica preroll Audio</legend>
            <label>
              # Primo:
              <input
                type="number" min="0"
                value={audio.first}
                onChange={e => setAudio(a => ({ ...a, first: +e.target.value }))}
              />
            </label>
            <label>
              # Pubblicità:
              <input
                type="number" min="0"
                value={audio.ad}
                onChange={e => setAudio(a => ({ ...a, ad: +e.target.value }))}
              />
            </label>
            <label>
              # Ultimo:
              <input
                type="number" min="0"
                value={audio.last}
                onChange={e => setAudio(a => ({ ...a, last: +e.target.value }))}
              />
            </label>
          </fieldset>

          {/* Video */}
          <fieldset>
            <legend>Modifica preroll Video</legend>
            <label>
              # Primo:
              <input
                type="number" min="0"
                value={video.first}
                onChange={e => setVideo(v => ({ ...v, first: +e.target.value }))}
              />
            </label>
            <label>
              # Pubblicità:
              <input
                type="number" min="0"
                value={video.ad}
                onChange={e => setVideo(v => ({ ...v, ad: +e.target.value }))}
              />
            </label>
            <label>
              # Ultimo:
              <input
                type="number" min="0"
                value={video.last}
                onChange={e => setVideo(v => ({ ...v, last: +e.target.value }))}
              />
            </label>
          </fieldset>

          {/* Canali */}
          <fieldset>
            <legend>Abilita preroll per i canali</legend>
            {CHANNELS.map(c => (
              <label key={c.id} className="checkbox-label">
                <input
                  type="checkbox"
                  checked={!!channels[c.id]}
                  onChange={e =>
                    setChannels(ch => ({ ...ch, [c.id]: e.target.checked }))
                  }
                />
                {c.key}
              </label>
            ))}
          </fieldset>

          <div className="params-actions">
            <button onClick={handleSave} disabled={saving}>
              {saving ? 'Salvando…' : 'Salva e Carica'}
            </button>
            <button onClick={onClose} disabled={saving}>
              Annulla
            </button>
          </div>
        </div>
      )}
    </Modal>
  )
}
